'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:CustomCurriculaCtrl
 * @description
 * # CustomCurriculaCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp').controller('CustomCurriculaCtrl', ['$scope','Session', function ($scope,Session) {

    $scope.login = function() {};

}]);
